import { render, staticRenderFns } from "./butor.vue?vue&type=template&id=f43c7a1a&"
import script from "./butor.vue?vue&type=script&lang=js&"
export * from "./butor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports